const queries = {
  en: {
    untitled_query: "Untitled Query ...",
    filter: {
      label: "Filter | Filters",
      group_tag_filters: "Group filters",
      spread_grouped_filters: "Spread grouped filters",
      toggle_tag_view: "Tag View",
      toggle_query_view: "Query View",
      filterAtArticleLevel: "Filter at Article Level",
      filterAtArticleLevelNot: "Do not filter at Article Level"
    },
    hidden_insight: "Hidden for non-admin users on Insight",
    shown_insight: "Showing for non-admin users on Insight",
    saved_queries: "Saved Queries",
    filters: "Filters",
    outputs: "Outputs",
    standard_breakdown: "Standard Breakdown",
    external_filters: "External Filters",
    type: "Type",
    relative: "Relative",
    fixed: "Fixed",
    drop_here: "Drop Here",
    no_data: "There is no data matching your query",
    no_rows: "There is no data matching your query",
    no_rows_due_to_user: "There is no data matching your query. It is possible that the filters / axis selected eliminate each other",
    filters_are_illogic: "There is no data matching your query. It is possible that the filters / axis selected eliminate each other",
    no_columns_due_to_user: "There is no data matching your query. It is possible that the filters / axis selected eliminate each other",
    actions: {
      run: "Run",
      reset: "Reset",
      save: "Save",
      save_as: "Save As"
    },
    time_periods: {
      current: "Current Periods",
      current_message: "Current Period will only be used during Preview",
      trend: "Trend Periods",
      trend_message: "Trend Period will only be used during Preview",
      fixed: "Fixed Periods",
      fixed_message: "Fixed Period will be saved for this query",
      comparative_period: "Comparative Period",
      from: "From",
      to: "To",
      form: {
        name: 'Custom Date Ranges',
        day: 'Day',
        period: 'Period'
      },
      custom_range: "Custom Range",
      time_zone: "UTC",
      most_recent_range: "Most recent period"
    },
    category_tags: {
      categories: "Categories",
      tags: "Tags",
      search: "Search...",
      empty: "There are no items to show.",
      any_tag: "All Tags"
    },
    advanced: {
      or: "Or",
      and: "And",
      not: "Not"
    },
    limit_options: {
      all: "All"
    },
    sort_options: {
      default: 'Sorted in alphabetical order',
      asc: 'Sorted in ascending order',
      desc: 'Sorted in descending order',
      date: 'Sorted by date'
    },
    draggable_list: {
      add_record: "Add New Record"
    },
    breakdown: {
      add_edit_header: "Add / Edit {0}",
      text: {
        name: "Name",
        search_string: "Search string"
      },
      time_settings_header: "{0} Settings",
      label: "Label",
      two_point: "Two-point",
      three_point: "Three-point",
      four_point: "Four-point",
      five_point: "Five-point",
      byline: "Byline"
    },
    output: {
      settings_header: "Settings",
      fields: {
        category_id: "Category",
        tag_id: "Tag",
        type: "Type",
        breakdown_id: "Standard Breakdown",
        article_count_label: "Label",
        mentions_label: "Label",
        rank_by_most_recent_period: "Rank by Most Recent Period",
        rank_by_aggregated_value: "Rank by Aggregated Value"
      },
      placeholders: {
        article_count_label: "Articles and Posts",
        trends_label: "Trend Percentage",
        mentions_label: "Mentions",
        percentage_tag_id: "Select a tag or type to search"
      },
      tooltips: {
        12: 'X (formerly Twitter), Facebook, Instagram, LinkedIn, TikTok',
        13: 'X (formerly Twitter)',
        14: 'Reddit',
        15: 'Reddit',
        17: 'X (formerly Twitter), Facebook, Instagram, LinkedIn, TikTok, Reddit',
        18: 'X (formerly Twitter), Facebook, TikTok',
        19: 'Instagram, TikTok',
        20: 'Facebook, LinkedIn',
        21: 'X (formerly Twitter)',
        23: 'Ranking defaults to aggregated totals. Use Edit (⚙) to switch to "Most Recent Period" mode.',
        24: 'In order to have a comparison, add a Trend Periods on Standard breakdown'
      }
    },
    external_filters_settings: {
      title: "Settings",
      hidden_tag_ids: {
        title: "Hidden Tags",
        text: "These tags will be hidden from \nPower Dashboards external filters"
      }
    },
    results_pagination: {
      limit: "Limit",
      order: "Order By"
    },
    save: {
      title: "Save Query",
      choose_folder: "Choose Folder",
      new_folder: "New Folder",
      folder_name: "Folder Name",
      query_name: "Name",
      target: "Target",
      reporting: "Reporting",
      portal: "Portal",
      share: "Share with others",
      project: "Project",
      rowsRequired: "Rows are required. Switch to Table View to add.",
      columnsRowsRequired: "Columns and Rows are required. Switch to Table View to add.",
      actions: {
        save: "Save",
        cancel: "Cancel",
        save_as: "Save As"
      }
    },
    admin: {
      add_query: "Add Query",
      refresh_queries: "Refresh Queries",
      force_refresh_queries: "Force refresh",
      bulk_date_update_queries: "Bulk Date Update",
      bulk_update_queries_date: {
        title: "Bulk Update Queries Date",
        note: "Update the queries date settings for selected folders: {total_folders} and queries: {total_queries}",
        change_all_queries: "Change all queries date period",
        bulk_update_date_tooltip: "Update the date range for selected queries (current periods only)",
        confirm: {
          title: "Confirm Bulk Update Queries Date",
          message: "Are you sure you want to update the queries date settings for selected folders: {total_folders} and queries: {total_queries}?"
        }
      },
      settings: "Settings",
      create_new: "Create a new article query",
      name_label: "Query Name",
      save: "Save",
      delete: "Delete Query",
      reset: "Reset",
      add: "Add",
      headers: {
        date: "Date Created",
        name: "Name",
        created_by_name: "Created By",
        last_updated: "Last Updated",
        target: 'Target',
        shared: 'Shared With Others',
      },
      is_private: {
        yes: 'Yes',
        no: 'No',
      },
      edit_settings_form: {
        title: 'Edit Settings'
      },
      refresh_queries_schedule: {
        title: "Refresh Queries Schedule",
        note: "Please note that time is considered as UTC",
        frequency: "Frequency",
        daily: "Daily",
        hourly: "Hourly",
        at_interval: "At Interval",
        run_at: "Run at: ",
        run_every: "Run every: "
      },
      bulk_update_excluded_modal: {
        title: 'Bulk Queries Date Update',
        message: 'The new dates were applied to queries using Current period. The following queries were not updated:',
        reason: 'These queries use Fixed or Trend period and must be updated manually if you need to change their dates.',
        query_list_header: 'Excluded queries (ID - Name)',
      }
    },
    folders: {
      name: 'Folder Name'
    },
    errors: {
      quarter: {
        dates_overlap: 'Dates Overlap',
        day_after_error: 'Dates must be sequential',
        full_year_exceeds: `The date range selected <strong> exceeds 12 Months</strong>. 
          <br> Try select the last date as <strong>{date}</strong>, for example.`,
        full_year_less: `The date range selected is <strong>less than 12 Months</strong>. 
          <br> Try select the last date as <strong>{date}</strong>, for example.`
      },
      default_title: "Error",
      default_text: "Something went wrong. Please try again later.",
      unable_refresh_queries: "Unable to refresh queries",
      unable_run_query: "Unable to run query",
      invalid_mv_requirements: "The project is required to have organizations, tags, and categories from Category Type <strong>Article Detail</strong> to successfully run queries.",
      mv_not_found: "Queries data is not available yet. Please create a queries schedule and check again later."
    },
    modal: {
      close: "Close"
    },
    export: {
      initiated: "Export Initiated",
      sql_running: "SQL Running",
      sql_finished: "Upload Running",
      receiving_row: "Receiving Rows",
      rows_received: "Processed",
      finished: "Export Download",
    },
    mv_refresh: {
      confirm: {
        title: "Confirmation required.",
        text: "This action will refresh all queries data. Do you want to continue?"
      },
      locked: {
        title: "Refresh queries in progress",
        text: "Unable to force refresh right now. Force refresh was requested on {date}. Please wait for it to complete."
      }
    },
    success_messages: {
      bulk_update_queries: 'Queries updated successfully',
      bulk_update_queries_excluded: '{count} query/queries were not updated (Fixed or Trend period).'
    },
    error_messages: {
      bulk_update_queries: 'Failed to update queries'
    },
    
  }
};

module.exports.queries = queries;